skrilla.controller('accountsCtrl', function ($scope, searchService, cacheService, currencyService) {
    $scope.pageKey = "accounts";
    $scope.systemAccountCurrencies = currencyService.getCurrencies();
    $scope.combinedAccounts = [];

    $scope.combinedAccounts = $scope.systemAccountCurrencies.map(function(currency){
        return {currency: currency, purpose: "CASH"};
        // searchService.get('accounts/system/CASH/' + currency + '/balance').then(function(response){
        //     $scope.combinedAccounts.push({currentBalance: response.data, currency: currency, purpose: "CASH"});
        // });
    });

    $scope.accounts = cacheService.getObjectOrElse("userAccountsTable", []);
    if($scope.accounts.length > 0){
        $scope.currency = $scope.accounts[0].currency;
    }

    $scope.getAccount = function(accounts, purpose){
        return accounts.filter(function(account){ return account.purpose === purpose })[0];
    }



});

